import firebase from "firebase/app";
import "firebase/firestore";
import "firebase/auth";
import settings from "../../settings.json";

const { config } = settings;

firebase.initializeApp(config);

const dbInstance = firebase.firestore();

export default firebase;
export const db = dbInstance;

export const auth = firebase.auth();
export const emailAuthProvider = firebase.auth.EmailAuthProvider.PROVIDER_ID;
export const googleAuthProvider = firebase.auth.GoogleAuthProvider.PROVIDER_ID;
